import { differenceInCalendarDays, isValid } from 'date-fns'

export function calculateDaysDifference(startDate: Date, endDate: Date): undefined | number {
  if (!isValid(startDate) || !isValid(endDate)) {
    return undefined
  }
  const localStartDate = getDateWithoutHoursFrom(startDate)
  const localEndDate = getDateWithoutHoursFrom(endDate)

  return differenceInCalendarDays(localEndDate, localStartDate)
}

function getDateWithoutHoursFrom(date: string | number | Date) {
  const localDate = new Date(date)
  localDate.setHours(0, 0, 0, 0)
  return localDate
}
